import React from 'react';
import {labelOrDefault, scorecardTypes} from 'records/Scorecard';
import classNames from 'classnames';

/**
 * Does the scoring scheme have this point value?
 *
 * @param scoringScheme
 * @param point
 * @return {boolean}
 */
function scoringSchemeContains(scoringScheme, point) {
  return !!scorecardTypes[scoringScheme].answers.find(a => a.key === point);
}

/**
 * Render this header if the scoring scheme contains this point
 *
 * @param scoringScheme
 * @param point
 * @param labelScheme
 * @param extraWide should we make the cells extra wide or not
 * @return null | <span>default or custom label</span>
 */
function conditionallyRenderHeaderFor(scoringScheme, point, labelScheme, extraWide) {
  return (
    scoringSchemeContains(scoringScheme, point) && (
      <span className={extraWide ? 'extra-wide' : null} key={point}>
        {labelOrDefault(scoringScheme, point, labelScheme)}
      </span>
    )
  );
}

export const ScorecardHeader = ({scoringScheme, labelScheme, extraWide}) => {
  return (
    <div className={classNames('right', 'point-header', extraWide && 'extra-wide-container')}>
      {['n/a', '0', '1', '2', '3', '4', '5'].map(point =>
        conditionallyRenderHeaderFor(scoringScheme, point, labelScheme, extraWide)
      )}
    </div>
  );
};
